import { Dispatch, SetStateAction } from 'react';

import { useMutation } from '@hooks/reactQuery';

import { generateHistoryCheckBranches } from '@api/hitoryCheck';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { THistoryCheckBranchesDTO } from '@interfaces/cmModule/dto/historyCheckDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { HISTORY_CHECK_BRANCHES } from '@constants/queryKeys';

export const useMutateGenerateHistoryCheckBranches = (setIsProgressRun: Dispatch<SetStateAction<boolean>>) => {
	const {
		data: generatedBranches,
		mutate: generateBranches,
		isLoading: isLoadingBranchesGenerated,
	} = useMutation<THistoryCheckBranchesDTO, { dumpId: string }>({
		mutationKey: [HISTORY_CHECK_BRANCHES],
		mutationFn: generateHistoryCheckBranches,
		onError: (err: IResponseError) => {
			setIsProgressRun(false);
			handleErrorFromMessage(err);
		},
	});

	return {
		generatedBranches,
		generateBranches,
		isLoadingBranchesGenerated,
	};
};
